import * as userInfoActions from './userInfoActions';
import userInfoReducer from './userInfoReducer';
import userInfoSagas from './userInfoSagas';
import * as userInfoSelectors from './userInfoSelectors';
import * as userInfoTypes from './userInfoTypes';

const { USERINFO_REDUCER_KEY } = userInfoTypes;

export { USERINFO_REDUCER_KEY, userInfoActions, userInfoReducer, userInfoSagas, userInfoSelectors, userInfoTypes };
